(function certificateRRHHModuleDefinition() {
    'use strict';

    angular.module('CertificateRRHH', ['ngFileUpload', 'ui.router', 'Config', 'Entities', 'CustomControls', 'ui.select', 'ui.selectExtend', 'TranslatedPaginator'
        , 'ClickOnce', 'FileDownloader', 'DoublyLinkedList', 'Process', 'DocumentViewer'
    ])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function certificateRRHHConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('certificate-rrhh-add', {
                    url: "/CertificateRRHH/Add",
                    templateUrl: config.resourceUrl('/views/certificate-rrhh/certificate-rrhh-add.html'),
                    controller: 'CertificateRRHHAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('CERTIFICATE START')
                });

                $stateProvider.state('certificate-rrhh-detail', {
                    url: "/CertificateRRHH/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/certificate-rrhh/certificate-rrhh-detail.html'),
                    controller: 'CertificateRRHHDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('CERTIFICATE READ')
                });

                $stateProvider.state('certificate-rrhh-edit', {
                    url: "/CertificateRRHH/Edit/{id}",
                    templateUrl: config.resourceUrl('/views/certificate-rrhh/certificate-rrhh-edit.html'),
                    controller: 'CertificateRRHHEditController',
                    authorize: true,
                    roles: loginProvider.roleCondition('CERTIFICATE READ')
                });

                $stateProvider.state('certificate-rrhh-find', {
                    url: "/CertificateRRHH/Find",
                    templateUrl: config.resourceUrl('/views/certificate-rrhh/certificate-rrhh-find.html'),
                    controller: 'CertificateRRHHFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('CERTIFICATE READ')
                });
            }
        ]);
})();
